import { CreateActions } from '../interface';
import { merge } from 'rxjs';
import { values } from 'ramda';

export const createActions: CreateActions = calculated => merge(...values(calculated));
